import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-non-individual-relationship",
  // imports: [],
  templateUrl: "./non-individual-relationship.component.html",
  styleUrl: "./non-individual-relationship.component.css",
  standalone: false,
})
export class NonIndividualRelationshipComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
